import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationKO from './locales/ko.json';
import translationEN from './locales/en.json';
import translationZH from './locales/zh.json';
import translationJA from './locales/ja.json';

const resources = {
  ko: {
    translation: translationKO
  },
  en: {
    translation: translationEN
  },
  zh: {
    translation: translationZH
  },
  ja: {
    translation: translationJA
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('selectedLanguage') || 'ko',
    fallbackLng: 'ko',
    react: {
      useSuspense: true  // Suspense 사용하여 i18n 초기화 완료까지 대기
    },
    interpolation: {
      escapeValue: false
    },
    debug: false  // 프로덕션에서는 false, 디버깅 시 true로 변경
  });

export default i18n;

